import {DomainGraphType, ObjectType} from 'app-core/framework/CoreObjectConstants';
import {asCoreObject, getObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {assert} from 'Asserts';

type SchemaInterfaceType = typeof DomainGraphType.FIELDSET | typeof DomainGraphType.SYSTEM_CATEGORY;

export default function getSchemaInterfaceType(interfaceId: string): SchemaInterfaceType {
  const objectType = getObjectType(asCoreObject({id: interfaceId}));
  assert(
    ([DomainGraphType.FIELDSET, DomainGraphType.SYSTEM_CATEGORY] as Array<ObjectType>).includes(objectType),
    `Expected Custom or Static Schema Interface, not ${objectType}`
  );
  return objectType as SchemaInterfaceType;
}
